/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CheckedOut/view.blocks to change it.
import React from 'react'
import Tysiav2CalendarCheckedOutIcon from 'DesignSystem/Svgs/Tysiav2CalendarCheckedOutIcon/index'



/** @type {import('Simple/types.js').View} */
export default function CheckedOut({
  children,
  viewPath = "/DesignSystem/AppointmentBookingStateTextWithIcon/StateIcon/CheckedOut",
  fill2
  
}) {
  return (<React.Fragment
>
<Tysiav2CalendarCheckedOutIcon
  viewPath={`${viewPath}/Tysiav2CalendarCheckedOutIcon`}
 fill2={fill2}
/>
{children}
</React.Fragment>)
}